{
  "companies_list_page": {
    "title": "Companies",
    "description": "Manage the companies that group your customers and share settings between them.",
    "footer": "Learn more about companies",
    "description_company_sync": "Manage the companies that group your customers and share settings between them. Company sync is on, so new companies are created on your e-commerce platform.",
    "create_button": "Create company",
    "import_button": "Import CSV",
    "sync_button": "Sync companies",
    "sync_started": "Company synchronisation started.",
    "search_placeholder": "Search companies",
    "load_error": "We couldn't load your companies. Please try again.",
    "empty_state": {
      "title": "No companies yet",
      "subtitle": "Create your first company to group customers and share settings between them."
    },
    "no_results_state": {
      "title": "No companies found",
      "subtitle": "No companies match your search. Try a different search term."
    },
    "table": {
      "caption": "Companies",
      "headings": {
        "name": "Name",
        "primary_customer": "Primary contact",
        "customer_group": "Customer group",
        "balance": "Balance"
      },
      "buttons": {
        "sections": "Sections"
      }
    },
    "primary_archived_notice": "This customer is archived. Please assign a new Primary Contact"
  },
  "company_form_page": {
    "create_title": "Create company",
    "edit_title": "Edit {name}",
    "description": "Companies group customers together and let them share settings such as price lists and payment terms.",
    "details": {
      "title": "Details",
      "name_label": "Company name",
      "name_placeholder": "Acme Corp",
      "external_id_label": "Platform ID",
      "external_id_placeholder": "Identifier on your e-commerce platform",
      "integration_id_label": "Integration ID",
      "integration_id_placeholder": "Identifier in another integration",
      "accounting_id_label": "Accounting ID",
      "accounting_id_placeholder": "Identifier in your accounting system"
    },
    "context": {
      "title": "Settings",
      "description": "Settings applied to customers belonging to this company.",
      "customer_group_label": "Customer group",
      "customer_group_placeholder": "Select a customer group",
      "price_lists_label": "Price lists",
      "price_lists_placeholder": "Select price lists",
      "sales_agent_groups_label": "Sales agent groups",
      "sales_agent_groups_placeholder": "Select sales agent groups",
      "addresses": {
        "description": "Control whether customers can save their own addresses to their address book, and enter a one-time address at checkout.",
        "allow_personal_addresses_label": "Personal addresses",
        "allow_one_time_addresses_label": "One-time addresses",
        "options": {
          "inherit": "Inherit from parent",
          "on": "Allowed",
          "off": "Not allowed"
        }
      },
      "payment_on_account": {
        "enable_label": "Enable payment on account",
        "balance_label": "Opening Balance",
        "balance_date_label": "Opening Balance Date",
        "credit_limit_label": "Credit limit",
        "currency_label": "Currency code",
        "currency_placeholder": "GBP",
        "net_terms_label": "Net terms",
        "net_terms_placeholder": "Select terms",
        "net_terms_options": {
          "7_days": "7 days",
          "15_days": "15 days",
          "30_days": "30 days",
          "45_days": "45 days",
          "60_days": "60 days",
          "90_days": "90 days"
        }
      }
    },
    "relations": {
      "title": "People",
      "description": "Choose the primary contact and admins for this company.",
      "primary_customer_label": "Primary contact",
      "admins_label": "Company admins"
    },
    "errors": {
      "currency": "Enter a 3-letter currency code (e.g. GBP).",
      "balance_date_invalid": "Please enter a valid date and time",
      "balance_empty": "Balance is required when Balance Date is provided",
      "balance_date_empty": "Balance Date is required when Balance is provided",
      "credit_limit_invalid": "Credit Limit value must be between {min} and {max}",
      "root_credit_limit_invalid": "Credit Limit value must greater than {min}"
    },
    "delete_confirm_title": "Delete company",
    "delete_confirm_body": "Are you sure you want to delete {name}? This can't be undone.",
    "company_sync_blocked": {
      "message": "Company sync is on, so companies can't be created here. Create the company on your e-commerce platform and it will sync across.",
      "back_button": "Back to companies"
    }
  }
}
